import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { Box, Card, CardContent, Container, Grid, LinearProgress, Paper, Tooltip, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import { nFormatter } from "../../Helpers";
import Skeleton from "@mui/material/Skeleton";
import DashboardCardInfo from "../../Components/common/DashboardCardInfo";
// import Highcharts from "highcharts/highmaps";
// import worldMap from "@highcharts/map-collection/custom/world.geo.json";
import HighchartsReact from "highcharts-react-official";
import Button from "../../Components/common/Button";
import { Scrollbar } from "react-scrollbars-custom";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
import HighchartsMap from "highcharts/modules/map";
// import mapData from "@highcharts/map-collection/custom/sa/sa-all.geo.json";
// import proj4 from "proj4";
// import mapData from "@highcharts/map-collection/countries/sa/sa-all.geo.json";

import Highcharts from "highcharts/highmaps";
import drilldownModule from "highcharts/modules/drilldown";
import dataModule from "highcharts/modules/data";
// import HighchartsReact from "highcharts-react-official";
// import mapData from "@highcharts/map-collection/countries/gb/gb-all.geo.json";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ReactComponent as ArrowDropUp } from "../../assets/ex_dashboard/arrow-up-graph-01.svg";
import { ReactComponent as ArrowDropDown } from "../../assets/ex_dashboard/arrow-down-graph-01.svg";
import { ReactComponent as ArrowStraight } from "../../assets/ex_dashboard/arrow-straight-graph-01.svg";
import { ReactComponent as AchieveTarget } from "../../assets/ex_dashboard/objective_5738807 (1).svg";
import Select from "react-select";
// import Highcharts from "highcharts/highstock";
import moment from "moment";
import MoreWidgets from "./MoreWidgets";
import SalesCard from "./components/SalesCard";
import PredictiveCard from "./components/PredictiveCard";
import AccountsCard from "./components/AccountsCard";
import DonatChart from "./components/DonatChart";
import SemiDonatChart from "./components/SemiDonatChart";
import VariablePieChart from "./components/VaraiblePieChart";
import SemiDonutChart from "./components/SemiDonatChart";
import SalesTrendCard from "./components/SaleTrendCard";
import SalesChart from "./components/HistoricalSalesChart";
import WidgetsNew from "./WidgetsNew";
import PieChartComponent from "./components/PieChartComponent";
import BarChart from "./components/BarChart";
import SalePerformanceTrackerWidgets from "./components/SalePerformanceTrackerWidgets";
import { useDispatch } from "react-redux";
import { addSaleApi1, addSaleApi10, addSaleApi14, addSaleApi15, addSaleApi2, addSaleApi20, addSaleApi21a, addSaleApi4, addSaleApi5, addSaleApi6b, addSaleApi8, removeSaleApi1, removeSaleApi10, removeSaleApi14, removeSaleApi2, removeSaleApi20, removeSaleApi21a, removeSaleApi4, removeSaleApi5, removeSaleApi6b, removeSaleApi8 } from "../../Actions/SaleDashboard";
import { useSelector } from "react-redux";

HighchartsMap(Highcharts);

drilldownModule(Highcharts);
dataModule(Highcharts);

const textStyle = {
  // marginLeft: 5,
  color: "#ffffff",
  textAlign: "left",
  fontSize: "22px",
  fontWeight: "700",
  fontStyle: "italic",
  display: "inline-block",
  whiteSpace: "nowrap",
  overflow: "hidden !important",
  // overflow: "hidden",
  textOverflow: "ellipsis",
  paddding: "0 2px 0 2px",
};
const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    background: "#ff5722 !important",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#548e25",
  },
}))(LinearProgress);

export const MaintenanceItemEmpty = React.memo(({size = "large"}) => {
  return (
    <div className={"mainten-section mainten"} style={{ padding: "5px" }}>
      <div className="mainten-section-header">
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          <Skeleton className="skeleton-pulse" width={150} height={25} />{" "}
          {/* </span>
        <span> */}
          <Skeleton className="skeleton-pulse" width={150} height={25} />{" "}
        </span>
      </div>

      <div className="mainten-section-body">
        <div className="mainten-split-section">
          <div>
            <Skeleton className="skeleton-pulse" width={"100%"} height={25} />
          </div>
          {size !== "small" && (
            <>
              <div>
                <Skeleton className="skeleton-pulse" width={"100%"} height={25} />{" "}
              </div>
              <div>
                <Skeleton className="skeleton-pulse" width={"100%"} height={25} />{" "}
              </div>{" "}
              <div>
                <Skeleton className="skeleton-pulse" width={"100%"} height={25} />{" "}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
});

const FiltersOption = [
  { label: "MTD", value: 1 },
  { label: "Last Month", value: 2 },
  { label: "Last 3 months", value: 3 },
  { label: "YTD", value: 4 },
  { label: "Last Year", value: 5 },
  { label: "ALL", value: 6 },
];

let fleetCountChart = {};
let fleetCountChart2 = {};
let overDueChart = {};
let heatMap = {};
let totalVehicles = 0;
let cogsChart = {};
// let cogsChartDaily ={}
// let sparePartsChart1 ={}
// let sparePartsChart ={}
// let servicesPartsChart ={}
// let verticalWiseChart = {}
// let areaWiseChart = {}
// let stationWiseChart = {}
let salesChartMonthly = {};
let salesChartYearly = {};
const sampleData = [
  { name: 'EV', y: 23.9 },
  { name: 'Hybrids', y: 12.6 },
  { name: 'Diesel', y: 37.0 },
  { name: 'Petrol', y: 26.4 }
];
const chartData = [
  { name: 'Achieved', value: 20 },
  { name: 'Remaining', value: 40 },
  { name: 'Remaining', value: 40 },

];
const data = {
  categories: ["(376) Unaizah-2", "(378) Al Tazij", "(380) Azeziah Station"],
  colors: ["#da5e5e", "#f50057", "#7b101b"],
  series: [
    {
      name: "Regions",
      data: [1576.69, 6666.54, 1156.36],
      showInLegend: false,
    },
  ],
};
const SaleDashboard = (props) => {
  const dispatch=useDispatch()
   const saleApi1Data = useSelector((state) => state.saleApi1);
   const saleApi2Data = useSelector((state) => state.saleApi2);
   const saleApi4Data = useSelector((state) => state.saleApi4);
   const saleApi5Data = useSelector((state) => state.saleApi5);
   const saleApi6bData = useSelector((state) => state.saleApi6b);
   const saleApi8Data = useSelector((state) => state.saleApi8);
   const saleApi10Data = useSelector((state) => state.saleApi10);
   const saleApi14Data = useSelector((state) => state.saleApi14);
   const saleApi15Data = useSelector((state) => state.saleApi15);
   const saleApi20Data = useSelector((state) => state.saleApi20);
   const saleApi20aData = useSelector((state) => state.saleApi20a);









  const { translate } = props
  const [allSaleData, setAllSaleData] = useState({}); //api1
  const [currentYearSale, setcurrentYearSale] = useState({}); // api2
  const [grossProfit, setGrossProfit] = useState({}); // api3
  const [accountsData, setAccountsData] = useState({}); // api5
  const [outstandingSummary, setOutstandingSummary] = useState(); // api5
  const [vehicleCount, setVehicleCount] = useState(); // api5
  const [vehiclesData, setVehiclesData] = useState(); // api9
  const [avgTicketPrice, setAvgTicketPrice] = useState(); // api10
  const [fleetCount, setFleetCount] = useState(); // api8
  const [overDue, setOverDue] = useState(); // api6
  const [cogsMonthly, setCogsMonthly] = useState(true); // api6
  const [businessPotential, setBusinessPotential] = useState(); // api5
  const [garageDataType, setGarageDataType] = useState("name");
  const [topologyData, setTopologyData] = useState();

  const [dataCategory, setDataCategory] = useState("all");
  const [cogsChartData, setCogsChartData] = useState({});
  const [cogsItems, setCogsItems] = useState();
  const [cogsServices, setCogsServices] = useState();
  const [cogsPackages, setCogsPackages] = useState();
  const [allCogsChartData, setAllCogsChartData] = useState();

  const [cogsSubItems, setCogsSubItems] = useState();
  const [cogsSubServices, setCogsSubServices] = useState();
  const [cogsSubPackages, setCogsSubPackages] = useState();
  const [cogsChartDaily, setCogsChartDaily] = useState({});
  const [date, setDate] = useState();

  const [servicesPartsChartData, setservicesPartsChartData] = useState();
  const [servicesPartsChart, setservicesPartsChart] = useState();
  const [servicesPartsChart1, setservicesPartsChart1] = useState();

  const [ownChart, setOwnChart] = useState({});
  const [ownChart1, setOwnChart1] = useState({});
  const [vehiclesChart, setVehiclesChart] = useState({});

  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [loader4, setLoader4] = useState(false);
  const [loader4a, setLoader4a] = useState(false);
  const [loader5, setLoader5] = useState(false);
  const [loader6, setLoader6] = useState(false);
  const [loader7, setLoader7] = useState(false);
  const [loader8, setLoader8] = useState(false);
  const [loader9, setLoader9] = useState(false);
  const [loader10, setLoader10] = useState(false);
  const [loader11, setLoader11] = useState(false);
  const [loader12, setLoader12] = useState(false);
  const [loader13, setLoader13] = useState(false);
  const [loader14, setLoader14] = useState(false);
  const [loader15, setLoader15] = useState(false);
  const [loader16, setLoader16] = useState(false);
  const [loader17, setLoader17] = useState(false);
  const [loader6b, setLoader6b] = useState(false);
  const [loader20, setLoader20] = useState(false);


  // const [loader16, setLoader16] = useState(false);
  const [showAllInventory, setShowAllInventory] = useState(false);
  const [sparePartsChart, setSparePartsChart] = useState();
  const [sparePartsChartNew, setSparePartsChartNew] = useState();
  const [sparePartsChart1, setSparePartsChart1] = useState();

  const [showAllVehicles, setShowAllVehicles] = useState(false);
  const [showAllServices, setShowAllServices] = useState(false);

  const [tab1, setTab1] = useState(FiltersOption[5]); // API bi/8
  const [tab2, setTab2] = useState(FiltersOption[5]); // API bi/4a
  const [tab3, setTab3] = useState(FiltersOption[5]); // API bi/4b
  const [tab4, setTab4] = useState(FiltersOption[5]); // API bi/10
  const [tab5, setTab5] = useState(FiltersOption[5]); // API bi/14a
  const [tab6, setTab6] = useState(FiltersOption[5]); // API bi/14b (garageType)
  const [tab7, setTab7] = useState(FiltersOption[5]); // API bi/14c (garageArea)
  const [tab8, setTab8] = useState(FiltersOption[5]); // API bi/16
  const [tab9, setTab9] = useState(FiltersOption[5]); // API bi/17
  const [tab10, setTab10] = useState(FiltersOption[5]); // api bi/20

  const [userLogsGraphData, setUserLogsGraphData] = useState({})
  const [verticalWiseChart, setVerticalWiseChart] = useState({});
  const [areaWiseChart, setAreaWiseChart] = useState({});
  const [stationWiseChart, setStationWiseChart] = useState({});
  const [areaWiseData, setAreaWiseData] = useState();

  const [garageTypeC, setGarageType] = useState("");
  const [garageAreaC, setGarageArea] = useState("");
  const [collectionsAndOutStanding, setCollectionsAndOutStanding] =
    useState("");
  const [collectionsAndOutStandingData, setCollectionsAndOutStandingData] =
    useState("");

  const [accountsDataChart, setAccountsDataChart] = useState({});
  const [showAccountsData, setShowAccountsData] = useState(false);
  const [showAccountsLoader, setShowAccountsLoader] = useState(false);
  const [showAccountsTitle, setShowAccountsTitle] = useState("");
  const [selectedDate14b, setSelectedDate14b] = useState({});

  const [data20a, setData20a] = useState({
    isLoading: false,
    isVisible: false,
    from: "",
    to: "",
    data: [],
  })

  const [screenSize, setScreenSize] = useState({
    xs: window.innerWidth < 600,
    sm: window.innerWidth > 600 && window.innerWidth < 960,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        xs: window.innerWidth < 600,
        sm: window.innerWidth > 600 && window.innerWidth < 960,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array to run the effect only once (on mount)

  const { xs, sm } = screenSize;

  useEffect(() => {
    if (garageTypeC) {
      let apiUrl;
      // API request with the updated garageTypeC
      if (selectedDate14b && selectedDate14b.to && selectedDate14b.from) {
        apiUrl = `/api/dashboards/bi/14b?garageType=${garageTypeC}&to=${selectedDate14b.to}&from=${selectedDate14b.from}&contractType=1&contractType=3`;
      } else {
        apiUrl = `/api/dashboards/bi/14b?garageType=${garageTypeC}&contractType=1&contractType=3`;
      }
      setLoader14(true);
      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          // Handle the API response data as needed
          // setAreaWiseData(data.data)
          // setStationWiseChart(processResponse14b(data.data || {}, true));
          // setGarageDataType("station");
          setAreaWiseChart(processResponse14b(data.data));

          setGarageDataType("area");
        })
        .catch((error) => {
          // Handle any errors that occur during the API request
          console.error("API Error:", error);
        })
        .finally(() => {
          setLoader14(false);
        });
    }
  }, [garageTypeC]);

  useEffect(() => {
    if (garageAreaC) {
      // API request with the updated garageTypeC
      let apiUrl;

      if (selectedDate14b && selectedDate14b.to && selectedDate14b.from) {
        apiUrl = `/api/dashboards/bi/14c?garageArea=${garageAreaC}&garageType=${garageTypeC}&to=${selectedDate14b.to}&from=${selectedDate14b.from}&contractType=1&contractType=3`;
      } else {
        apiUrl = `/api/dashboards/bi/14c?garageArea=${garageAreaC}&garageType=${garageTypeC}&contractType=1&contractType=3`;
      }
      setLoader14(true);
      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          // Handle the API response data as needed
          setAreaWiseData(data.data);
          setStationWiseChart(processResponse14b(data.data || {}, true));
          setGarageDataType("station");
        })
        .catch((error) => {
          // Handle any errors that occur during the API request
          console.error("API Error:", error);
        })
        .finally(() => {
          setLoader14(false);
        });
    }
  }, [garageAreaC]);
  // Rest of your component code
  const storeDateAndTime = (res) => {
    setData20a((prevState) => ({
      ...prevState,
      from: res.from,
      to: res.to
    }))
  }

  const handleChange = (name, e) => {
    const res = getToFrom(e.value);
    if (res) {
      if (name === "tab1") {
        setTab1(e);
        getEXD8(res);
      } else if (name === "tab2") {
        setTab2(e);
        getEXD4(res);
      } else if (name === "tab3") {
        // not in use
        setTab3(e);
        getEXD8(res);
      } else if (name === "tab4") {
        setTab4(e);
        getEXD10(res);
      } else if (name === "tab5") {
        setTab5(e);
        getEXD14(res);
        setSelectedDate14b(res);
      } else if (name === "tab10") {
        setTab10(e);
        storeDateAndTime(res)
        getEXD20(res);
      }
      else if (name === "tab6") {
        setTab6(e);
        handleVerticalClick("pointData", res);
      } else if (name === "tab7") {
        setTab7(e);
        handleVerticalClick2("pointData", res);
      } else if (name === "tab8") {
        setTab8(e);
        getEXD16(res);
        setShowAllInventory(false);
      } else if (name === "tab9") {
        setTab9(e);
        getEXD17(res);
        setShowAllServices(false);
      }
    }
  };

  useEffect(() => {
    let timezone = "";
    let date = {};
    if (
      props.logInUser &&
      props.logInUser.attributes &&
      props.logInUser.attributes.timezone
    ) {
      timezone = props.logInUser.attributes.timezone;
    } else {
      timezone = "Asia/Riyadh";
    }
    const now = moment().tz(timezone);

    // ======== this part is for dashboards/cms/16, stations part, start of year YTD=========

    const startOfYear = now.clone().startOf("year");
    const endOfDay = now.clone().endOf("day");

    // ======== this part is for dashboards/cms/16, stations part, start of month MTD=========

    const startOfMonth = now.clone().startOf("month");
    const endOfMonth = now.clone().endOf("month");

    // date = {
    //   //YTD obj
    //   to: endOfDay.toISOString(),
    //   from: startOfYear.toISOString(),
    // };

    // Adjust the date object for the last year
    const lastYearStart = startOfYear.clone().subtract(1, "year");
    const lastYearEnd = endOfDay.clone().subtract(1, "year");

    date = {
      // YTD obj for last year
      to: lastYearEnd.toISOString(),
      from: lastYearStart.toISOString(),
    };
    if(saleApi1Data && Object.keys(saleApi1Data).length > 0){
     setAllSaleData(saleApi1Data)
    }else{
      getEXD1();
    }
    if(saleApi2Data && Object.keys(saleApi2Data).length > 0){
setcurrentYearSale(saleApi2Data)
    }else{
      getEXD2();
    }

    // getEXD3();
    // getEXD4(date);
 if (saleApi4Data && Object.keys(saleApi4Data).length > 0) {
          setCogsItems(saleApi1Data.cogsItems);
        setCogsServices(saleApi4Data.cogsServices);
        setCogsPackages(saleApi4Data.cogsPackages);
        setCogsChartData(saleApi4Data?.chart);
}else{
  getEXD4()
}
//  else {
//   getEXD4();
// }
if(saleApi5Data&&Object.keys(saleApi5Data).length>0){
  setAccountsData(saleApi5Data)
}else{
  getEXD5();
}

    if(saleApi6bData&&Object.keys(saleApi6bData).length>0){
  setCollectionsAndOutStanding(saleApi6bData.chart)
}else{
  getEXD6b();
}
if(saleApi8Data&&Object.keys(saleApi8Data).length>0){
setFleetCount(saleApi8Data.fleetCount)
fleetCountChart2=saleApi8Data.chart
}
else{
  getEXD8();
}
if(saleApi10Data&&Object.keys(saleApi10Data).length>0){
  setAvgTicketPrice(saleApi10Data)
}
else{
  getEXD10();
}
if(saleApi14Data&&Object.keys(saleApi14Data).length>0){
  setVerticalWiseChart(saleApi14Data)
}
// else{
//   getEXD14();
// }
if(saleApi15Data&&Object.keys(saleApi15Data).length>0){
setBusinessPotential(saleApi15Data)
}
// else{
//   getEXD15();
// }
if (saleApi20Data && saleApi20Data.length > 0) {
  setUserLogsGraphData(processResponse20(saleApi20Data, false));
} else {
  getEXD20();
}


    // // Function to reload the page
    // const reloadPage = () => {
    //   window.location.reload();
    // };
    // const reloadInterval = 900000;
    // const intervalId = setInterval(reloadPage, reloadInterval);
    // return () => {
    //   clearInterval(intervalId);
    // };
  }, []);

  const getEXD6b = async (res) => {
    try {
      setLoader6b(true);
      let api;
      if (res && res.to && res.from) {
        api = `/api/dashboards/cms/12?to=${res.to}&from=${res.from}&contractType=1&contractType=3&userType=3`;
      } else {
        api = `/api/dashboards/cms/12?contractType=1&contractType=3&userType=3`;
      }
      const response = await fetch(api);
      // const response = await fetch('/api/dashboards/bi/8');
      const data = await response.json();
      let res1 = data?.data || {};
      // let balancePercentage =
      // res.totalOutstandingBalance > res.totalPaid
      //   ? (res.totalPaid / res.totalSaleNetAmount) * 100
      //   : (res.totalPaid / res.totalSaleNetAmount) * 100;

      //   const obj = {
      //   balancePercentage: balancePercentage,
      //   ...res1,
      //   }
      // const sum = Object.values(res1).reduce((accumulator, value) => accumulator + value, 0);
      const sum =
        (res1["amountCredited"] || 0) +
        (res1["totalOutstanding"] || 0) +
        (res1["totalPaid"] || 0);
      setCollectionsAndOutStandingData(sum);
      let chart = processResponse16(res1, true);
      const updatedObject={
        sum,
        chart
      }
      setCollectionsAndOutStanding(chart);
      dispatch(addSaleApi6b(updatedObject));
      //
      // Process and update state as needed
    } catch (error) {
      dispatch(removeSaleApi6b());

      console.error("Error fetching EXD8 data:", error);
    } finally {
      setLoader6b(false);
    }
  };

  const getEXD1 = async () => {
    try {
      setLoader1(true);
      const response = await fetch("/api/dashboards/bi/1?contractType=1&contractType=3");
      const data = await response.json();
      if (data?.statusCode === "200") {
   dispatch(addSaleApi1(data.data));
        setAllSaleData(data?.data || {});
      } else {
        setLoader1(true);
      }
    } catch (error) {
      dispatch(removeSaleApi1());
      console.error("Error fetching EXD1 data:", error);
    } finally {
      setLoader1(false);
    }
  };
  const getEXD2 = async () => {
    try {
      setLoader2(true);
      const response = await fetch("/api/dashboards/bi/2?contractType=1&contractType=3");
      const data = await response.json();
      if (data?.statusCode === "200") {
        const chartResponse=processResponse2(data?.data !== "N/A" ? data?.data : {})
           dispatch(addSaleApi2(chartResponse));
        setcurrentYearSale(chartResponse);
      } else {
        setLoader2(true);
      }
    } catch (error) {
      dispatch(removeSaleApi2());
      console.error("Error fetching EXD2 data:", error);
    } finally {
      setLoader2(false);
      getEXD15()
    }
  };
  const getEXD4 = async (res) => {
    try {
      setLoader4(true);
      let api;
      if (res && res.to && res.from) {
        api = `/api/dashboards/bi/4a?to=${res.to}&from=${res.from}&contractType=1&contractType=3`;
      } else {
        api = `/api/dashboards/bi/4a?contractType=1&contractType=3`;
      }
      // res.to && res.from ? api= `/api/dashboards/bi/4a?to=${res.to}&from=${res.from}` : api =`/api/dashboards/bi/4a`
      const response = await fetch(api);
      const data = await response.json();
     if (data?.statusCode === "200") {
  const dataArray = Array.isArray(data?.data) ? data?.data : [];

  const sorted = dataArray?.sort((a, b) =>
    a?.yearMonth > b?.yearMonth ? 1 : -1
  );
  const normalizedData = sorted?.flatMap(item => ([
    {
      yearMonth: item?.yearMonth,
      categoryName: "items",
      saleNetAmount: item?.saleNetItems || 0
    },
    {
      yearMonth: item?.yearMonth,
      categoryName: "packages",
      saleNetAmount: item?.saleNetPackages || 0
    },
    {
      yearMonth: item?.yearMonth,
      categoryName: "services",
      saleNetAmount: item?.saleNetServices || 0
    }
  ]));
setAllCogsChartData(normalizedData);

const itemsArray = normalizedData?.filter(i => i?.categoryName === "items");
const packagesArray = normalizedData?.filter(i => i?.categoryName === "packages");
const servicesArray = normalizedData?.filter(i => i?.categoryName === "services");

setCogsItems(itemsArray);
setCogsPackages(packagesArray);
setCogsServices(servicesArray);
const chartResponse = processResponse13(normalizedData);
setCogsChartData(chartResponse);
const updatedObject = {
  chart: chartResponse,
  cogsItems: itemsArray,
  cogsServices: servicesArray,
  cogsPackages: packagesArray
};

dispatch(addSaleApi4(updatedObject));
} else {
        setLoader4(true);
      }
    } catch (error) {
      dispatch(removeSaleApi4());

      console.error("Error fetching EXD4 data:", error);
    } finally {
      setLoader4(false);
    }
  };
  const getEXD5 = async () => {
    try {
      setLoader5(true);
      const response = await fetch("/api/dashboards/bi/5?contractType=1&contractType=3");
      const data = await response.json();

      setAccountsData(data?.data || {});
      dispatch(addSaleApi5(data?.data||{}));
    } catch (error) {
            dispatch(removeSaleApi5());

      console.error("Error fetching EXD5 data:", error);
    } finally {
      setLoader5(false);
      // getEXD10()
    }
  };
  const getEXD6 = async () => {
    try {
      setLoader6(true);
      const response = await fetch("/api/dashboards/bi/6?contractType=1&contractType=3");
      const data = await response.json();

      overDueChart = processResponse10(data?.data || {}, true);
      setOverDue(data?.data || {});
      // Process and update state as needed
    } catch (error) {
      console.error("Error fetching EXD6 data:", error);
    } finally {
      setLoader6(false);
    }
  };
  const getEXD7 = async () => {
    try {
      setLoader7(true);
      const response = await fetch("/api/dashboards/bi/7?contractType=1&contractType=3");
      const data = await response.json();
      let allData = data?.data ? data?.data.list : {};
      const filteredData = {};

      for (const key in allData) {
        if (allData[key] >= 1) {
          filteredData[key] = allData[key];
        }
      }
      const obj = { ...data?.data, list: filteredData };
      setOutstandingSummary(obj || {});

      // Process and update state as needed
    } catch (error) {
      console.error("Error fetching EXD7 data:", error);
    } finally {
      setLoader7(false);
    }
  };
  const getEXD8 = async (res) => {
    try {
      setLoader8(true);
      let api;
      if (res && res.to && res.from) {
        api = `/api/dashboards/bi/8?to=${res.to}&from=${res.from}&contractType=1&contractType=3`;
      } else {
        api = `/api/dashboards/bi/8?contractType=1&contractType=3`;
      }
      const response = await fetch(api);
      // const response = await fetch('/api/dashboards/bi/8');
      const data = await response.json();

      let heading1 = "Total Vehicles vs Vehicles Served";

      let colors1 = ["#f2b400", "#673ab7"];
      const obj1 = {
        totalServedVehicles: data?.data?.totalServedVehicles || 0,
        totalFleet: data?.data?.totalFleet || 0,
      };

      let heading2 = "Total Invoices vs Vehicles Served";
      let colors2 = ["#548e25", "#0288d1"];
      const obj2 = {
        totalDeliveryNotesCount: data?.data?.totalDeliveryNotesCount || 0,
        totalServedVehicles: data?.data?.totalServedVehicles || 0,
      };
      let avgInvoice = Math.ceil(
        data?.data?.totalDeliveryNotesCount / data?.data?.totalServedVehicles
      );
      let avgInvoice1 = isNaN(avgInvoice) ? 0 : avgInvoice;
      let innerLabel = `Visits Per Unit`;

      // Add HTML and CSS styles to the inner label
      let formattedLabel = '<div style=" color: #0288d1; ">';
      formattedLabel +=
        '<span style="color: green;font-size:15px ;">' +
        avgInvoice1 +
        "</span>";
      formattedLabel += "<br>";
      formattedLabel +=
        '<span style="color: #0288d1; font-size:11px ;">' +
        props.translate(innerLabel) +
        "</span>";
      formattedLabel += "</div>";

      const unitsPercent = (
        (data?.data?.totalServedVehicles / data?.data?.totalFleet) *
        100
      )?.toFixed(2);
      const unitsPercent1 = isNaN(unitsPercent) ? 0 : unitsPercent;
      let formattedLabel1 = '<div style=" color: #f7b400; font-size:15px ;">';
      // formattedLabel += innerLabel;
      // formattedLabel += '<br>';
      formattedLabel1 +=
        '<span style="color: #f7b400; font-size:15px ;">' +
        Math.abs(unitsPercent1) +
        " % </span>";
      formattedLabel1 += "</div>";
      // Rest of your code

      fleetCountChart = processResponse3(
        obj1,
        colors1,
        "",
        false,
        formattedLabel1
      );
      fleetCountChart2 = processResponse3(
        obj2,
        colors2,
        "",
        false,
        formattedLabel
      );

      const updatedData={
        chart:fleetCountChart2,
        fleetCount:data.data
      }
      setFleetCount(data.data);
      dispatch(addSaleApi8(updatedData))


      // Process and update state as needed
    } catch (error) {
      dispatch(removeSaleApi8())
      console.error("Error fetching EXD8 data:", error);
    } finally {
      setLoader8(false);
      // getEXD4()
    }
  };
  const getEXD9 = async () => {
    try {
      setLoader9(true);
      const response = await fetch("/api/dashboards/bi/9?contractType=1&contractType=3");
      const data = await response.json();
      // processResponse3

      let colors = ["#f2b400", "#673ab7"];

      let heading = "New Vehicles Vs Old Vehicles";
      const obj1 = {
        newVehicles: data?.data?.newVehicles || 0,
        oldVehicles: data?.data?.oldVehicles || 0,
      };
      let formattedLabel1 = '<div style=" color: #f7b400; font-size:15px ;">';
      // formattedLabel += innerLabel;
      // formattedLabel += '<br>';
      formattedLabel1 +=
        '<span style="color: #f7b400; font-size:15px ;">' +
        " + " +
        obj1?.newVehicles || 0 + " % </span>";
      formattedLabel1 += "</div>";
      setVehiclesData(
        processResponse3(obj1, colors, "", false, formattedLabel1)
      );
      // setVehiclesData(vehicleGrapgh)

      // Process and update state as needed
    } catch (error) {
      console.error("Error fetching EXD9 data:", error);
    } finally {
      setLoader9(false);
    }
  };
  const getEXD10 = async (res) => {
    try {
      setLoader10(true);
      // let api;
      // res.to && res.from ? api= `/api/dashboards/bi/10?to=${res.to}&from=${res.from}` : api =`/api/dashboards/bi/10`
      // const response = await fetch(api);
      const response = await fetch("/api/dashboards/bi/10?contractType=1&contractType=3");

      const data = await response.json();

      let colors1 = ["#f2b400", "#673ab7"];
      const obj1 = {
        ytdAverageTicket: data?.data?.ytdAverageTicket || 0,
        lyAverageTicket: data?.data?.lyAverageTicket || 0,
      };
      let chart = processResponse3(obj1, colors1);

      setAvgTicketPrice(data.data || {});
      dispatch(addSaleApi10(data.data||{}))

      // Process and update state as needed
    } catch (error) {
      dispatch(removeSaleApi10())
      console.error("Error fetching EXD10 data:", error);
    } finally {
      setLoader10(false);
    }
  };
  const getEXD11 = async () => {
    try {
      setLoader11(true);
      const response = await fetch("/api/dashboards/bi/11?contractType=1&contractType=3");
      const data = await response.json();

      setTopologyData(data?.data || []);
      // heatMap = processResponse11(data.data);

      // Process and update state as needed
    } catch (error) {
      console.error("Error fetching EXD11 data:", error);
    } finally {
      setLoader11(false);
    }
  };
  // const getEXDTopology = async () => {
  //   try {
  //     setTopologyLoader(true);
  //     const topology1 = await fetch(
  //       'https://code.highcharts.com/mapdata/countries/sa/sa-all.topo.json'
  //     ).then((response) => response.json());
  //     setTopology(topology1)
  //   } catch (error) {
  //     console.error('Error fetching EXD11 data:', error);
  //   } finally {
  //     setTopologyLoader(false);
  //   }
  // };
  const getEXD12 = async () => {
    try {
      setLoader12(true);
      const response = await fetch("/api/dashboards/bi/12?contractType=1&contractType=3");
      const data = await response.json();

      if (Object.keys(data?.data).length > 0) {
        const sortedData = Object.entries(data?.data || {}).sort(
          (a, b) => b[1] - a[1]
        );

        // Take the top 7 items and create a new object
        const topItems = {};
        for (let i = 0; i < 7; i++) {
          const [key, value] = sortedData[i];
          topItems[key] = value;
        }

        // Calculate the sum of remaining values
        const sumOfRemaining = sortedData
          .slice(7)
          .reduce((sum, [, value]) => sum + value, 0);

        // Create the final object with top items and "Other"
        const obj = {
          ...topItems,
          Other: {
            Total: sumOfRemaining,
            ...sortedData.slice(7).reduce((other, [key, value]) => {
              other[key] = value;
              return other;
            }, {}),
          },
        };

        setOwnChart(obj);
        setOwnChart1(data.data || {});
        setVehiclesChart(processResponse4(obj));
        setVehicleCount(data.data);
      } else {
        setVehiclesChart(processResponse4({}));
        setVehicleCount({});
      }
      // Process and update state as needed
    } catch (error) {
      console.error("Error fetching EXD12 data:", error);
    } finally {
      setLoader12(false);
    }
  };

  // const getEXD13 = async () => {
  //   try {
  //     setLoader13(true);
  //     const response = await fetch('/api/dashboards/13');
  //     const data = await response.json();
  //     // Process and update state as needed
  //   } catch (error) {
  //     console.error('Error fetching EXD13 data:', error);
  //   } finally {
  //     setLoader13(false);
  //   }
  // };
  const getEXD14 = async (res) => {
    try {
      let api;
      if (res && res.to && res.from) {
        api = `/api/dashboards/bi/14a?to=${res.to}&from=${res.from}&contractType=1&contractType=3`;
      } else {
        api = `/api/dashboards/bi/14a?contractType=1&contractType=3`;
      }
      setLoader14(true);
      const response = await fetch(api);
      const data = await response.json();
      const chart= processResponse16(data?.data !== "N/A" ? data?.data : {})
      setVerticalWiseChart(chart);
      dispatch(addSaleApi14(chart))
    } catch (error) {
      dispatch(removeSaleApi14())
      console.error("Error fetching EXD14 data:", error);
    } finally {
      setLoader14(false);
    }
  };

  const getEXD20 = async (res) => {
    try {
      let api;
      if (res && res.to && res.from) {
        api = `/api/dashboards/bi/20?to=${res.to}&from=${res.from}&contractType=1&contractType=3`;
      } else {
        api = `/api/dashboards/bi/20?contractType=1&contractType=3`;
      }
      setLoader20(true);

      // res && res.to && res.from ? api= `/api/dashboards/bi/14a?to=${res.to}&from=${res.from}` : api =`/api/dashboards/bi/14a`
      const response = await fetch(api);

      // const response = await fetch('/api/dashboards/bi/14a');
      const data = await response.json();

      // Process and update state as needed
    const validData = data?.data !== "N/A" ? data?.data : [];
    dispatch(removeSaleApi21a());
    setUserLogsGraphData(processResponse20(validData, false));
    dispatch(addSaleApi20(validData));
    } catch (error) {
      dispatch(removeSaleApi20())
      console.error("Error fetching EXD14 data:", error);
    } finally {
      setLoader20(false);
      getEXD14()
    }
  };
  const getEXD20a = async () => {
    const { userType, from, to } = data20a
    try {
      let api;
      if (from && to) {
        api = `/api/dashboards/bi/20a?to=${to}&from=${from}&contractType=1&contractType=3&userType=${userType}`;
      } else {
        api = `/api/dashboards/bi/20a?contractType=1&contractType=3&userType=${userType}`;
      }
      setData20a((prevState) => ({
        ...prevState,
        isLoading: true,
      }));

      const response = await fetch(api);
      const data = await response.json();

      setData20a((prevState) => ({
        ...prevState,
        isLoading: false,
        data: data?.data,
      }));
      dispatch(addSaleApi21a(userType,data.data))
    } catch (error) {
      console.error("Error fetching EXD20a data:", error);
      dispatch(addSaleApi21a(userType,[]))

      setData20a((prevState) => ({
        ...prevState,
        isLoading: false,
        isVisible: false,
        data: [],
      }));
    } finally {
      // Just make sure loading is false (optional here since set above)
      setData20a((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const getEXD15 = async () => {
    try {
      setLoader15(true);
      const response = await fetch("/api/dashboards/bi/15?contractType=1&contractType=3");
      const data = await response.json();

      // const totalCount = data?.data !=='N/A' ? data?.data?.list?.reduce((total, item) => total + item.serviceCount, 0) : 0;

      //     // Add the totalCount to the response
      //     const modifiedResponse = {
      //       ...data.data,
      //       totalCount,
      //     };

      setBusinessPotential(data?.data !== "N/A" ? data?.data : {});
      dispatch(addSaleApi15(data?.data !== "N/A" ? data?.data : {}))
    } catch (error) {
      dispatch(removeSaleApi5())
      console.error("Error fetching EXD15 data:", error);
    } finally {
      setLoader15(false);
      // getEXD8()
    }
  };
  const getEXD16 = async (res) => {
    try {
      setLoader16(true);
      let api;
      if (res && res.to && res.from) {
        api = `/api/dashboards/bi/16?to=${res.to}&from=${res.from}&contractType=1&contractType=3`;
      } else {
        api = `/api/dashboards/bi/16?contractType=1&contractType=3`;
      }
      // res.to && res.from ? api= `/api/dashboards/bi/16?to=${res.to}&from=${res.from}` : api =`/api/dashboards/bi/16`
      const response = await fetch(api);
      // const response = await fetch('/api/dashboards/bi/16');
      const data = await response.json();

      let items = data?.data || [];
      items.sort((a, b) => b.usedCount - a.usedCount);

      // Pick the top 7 items
      const top7Items = items.slice(0, 7);

      // Calculate the sum of usedCount for the remaining items
      const remainingItems = items.slice(7);
      const sumOfRemainingCounts = remainingItems.reduce(
        (sum, item) => sum + item.usedCount,
        0
      );

      // Construct the arr1 array
      const arr1 = [...top7Items];

      // Add the "others" item to arr1
      arr1.push({
        itemCode: "Other",
        itemName: "Other",
        usedCount: sumOfRemainingCounts,
        list: remainingItems.map((item) => ({
          itemCode: item.itemCode,
          itemName: item.itemName,
          usedCount: item.usedCount,
        })),
      });

      // Output arr1
      let colors = [
        "#f2b400",
        "#0288d1",
        "#62e854",
        "#ff5722",
        "#548e25",
        "#673ab7",
        "#be1be1",
        "#005e20",
      ];
      let heading = "Spare Parts Group Wise";

      setSparePartsChart(arr1);

      setSparePartsChart1(items);

      setSparePartsChartNew(processResponse14(arr1));

      // Process and update state as needed
    } catch (error) {
      console.error("Error fetching EXD16 data:", error);
    } finally {
      setLoader16(false);
    }
  };
  const getEXD17 = async (res) => {
    try {
      setLoader17(true);
      let api;
      if (res && res.to && res.from) {
        api = `/api/dashboards/bi/17?to=${res.to}&from=${res.from}&contractType=1&contractType=3`;
      } else {
        api = `/api/dashboards/bi/17?contractType=1&contractType=3`;
      }
      // res.to && res.from ? api= `/api/dashboards/bi/17?to=${res.to}&from=${res.from}` : api =`/api/dashboards/bi/17`
      const response = await fetch(api);
      // const response = await fetch('/api/dashboards/bi/17');
      const data = await response.json();

      // servicesPartsChart = processResponse15(data.data);
      let items = data.data || [];
      items.sort((a, b) => b.usedCount - a.usedCount);

      // Pick the top 7 items
      const top7Items = items.slice(0, 7);

      // Calculate the sum of usedCount for the remaining items
      const remainingItems = items.slice(7);
      const sumOfRemainingCounts = remainingItems.reduce(
        (sum, item) => sum + item.usedCount,
        0
      );

      // Construct the arr1 array
      const arr1 = [...top7Items];

      // Add the "others" item to arr1
      arr1.push({
        itemCode: "Other",
        itemName: "Other",
        usedCount: sumOfRemainingCounts,
        list: remainingItems.map((item) => ({
          itemCode: item.itemCode,
          itemName: item.itemName,
          usedCount: item.usedCount,
        })),
      });

      // Output arr1
      let colors = [
        "#f2b400",
        "#0288d1",
        "#62e854",
        "#ff5722",
        "#548e25",
        "#673ab7",
        "#be1be1",
        "#005e20",
      ];
      let heading = "Services Group Gise";
      setservicesPartsChart(arr1);
      setservicesPartsChart1(items);
      setservicesPartsChartData(processResponse14(arr1));

      // Process and update state as needed
    } catch (error) {
      console.error("Error fetching EXD17 data:", error);
    } finally {
      setLoader17(false);
    }
  };

  //  function to process response2 data
  const processResponse2 = (res) => {
    // Extract the sales values from the response object
    const { currentYearSale, lastYearSale } = res;

    const saleDifference = currentYearSale - lastYearSale;
    const percentageChange = (saleDifference / Math.abs(lastYearSale)) * 100;

    const changeType = saleDifference > 0 ? "increase" : "decrease";

    const result = {
      // chartOptions:chartOptions,
      currentYearSale: currentYearSale, // Keep currentYearSale as a number
      lastYearSale: lastYearSale, // Keep lastYearSale as a number
      saleDifference: Math.abs(saleDifference), // Store as a number
      percentageChange: percentageChange, // Store as a number
      changeType: changeType,
    };
    return result;
  };

  //  function to process response1 data
  const processResponse3 = (data, colors, label, per, innerLAbel) => {
    const dataPoints = [];

    // Define the label mappings
    const labelMappings = {
      currentYearSale: "Current Month Sales",
      currentMonthProfit: "Current Month Gross Profit",
      lastMonthProfit: "Prior Month Gross Profit",
      lastYearSale: "Prior Month Sales",
      newVehicles: "New VINs Added",
      oldVehicles: "Old VIN Count",
      totalServedVehicles: "Total Units Served",
      totalFleet: "Total Fleet on Platform",
      totalDeliveryNotesCount: "Total Invoices",
      ytdAverageTicket: "Current Month",
      lyAverageTicket: "Last Month",
      // Add more mappings as needed
    };

    for (const key in data) {
      const renamedLabel = labelMappings[key] || key; // Use the mapped label or the original key
      dataPoints.push({
        name: props.translate(renamedLabel),
        y: data[key],
      });
    }

    // Ensure that the number of colors matches the number of data points
    const validColors = colors.slice(0, dataPoints.length);

    for (let i = 0; i < dataPoints.length; i++) {
      dataPoints[i].color = validColors[i] || "#000000"; // Default to black if not enough colors provided
    }

    return {
      chart: {
        type: "pie",
        height: "300px",
      },
      // title: {
      //   text: label ? `<strong>${label}</strong>` : '',
      // },
      title: {
        text: innerLAbel,
        align: "center",
        verticalAlign: "middle",
        y: 0,
      },
      tooltip: {
        formatter: function () {
          const isSARRequired =
            this.key === "Current Month Sales" ||
            this.key === "Current Month Gross Profit" ||
            this.key === "Prior Month Sales" ||
            this.key === "Prior Month Gross Profit";

          let tooltipText =
            "<strong>" +
            this.key +
            "</strong>" +
            " <br>" +
            "<strong>" +
            Number(this.y).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) +
            "</strong>";

          if (isSARRequired) {
            tooltipText += " SAR"; // Add "SAR" to the tooltip
          }

          return tooltipText;
        },
      },

      plotOptions: {
        pie: {
          innerSize: "50%", // Set the inner size to create the donut effect
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
            format: "{point.name}: {point.percentage:.1f}%",
          },
          showInLegend: true, // Show legend instead of data labels
        },
      },
      legend: {
        layout: "horizontal", // Display the legend horizontally
        align: "center",
        verticalAlign: "bottom", // Show legend below the chart
        itemStyle: {
          color: "black", // Color of legend text
        },
        maxHeight: 200, // Set a fixed height
        labelFormatter: function () {
          const point = dataPoints[this.index];
          let label;

          if (point.name === "Current Month Gross Profit" && per) {
            label =
              point.name +
              " : " +
              Number(this.y).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });

            let formattedLabel =
              '<div style="display: flex; justify-content: space-between;">';
            formattedLabel +=
              '<span style="color:' +
              point.color +
              ';">' +
              label +
              " SAR " +
              "</span>";

            // const percentage = (((point.y - data["lastMonthProfit"]) / data["lastMonthProfit"]) * 100).toFixed(2);

            // const icon = percentage > 0 ? '⬆' : '⬇';
            // const textColor = percentage > 0 ? 'green' : 'red';
            // formattedLabel += '<span style="color:' + textColor + '; margin-left: 10px;">' + '    ' + icon + ' ' + Math.abs(percentage) + '% </span>';

            formattedLabel += "</div>";

            return formattedLabel;
          } else if (point.name === "Prior Month Gross Profit") {
            label =
              point.name +
              " : " +
              this.y.toLocaleString({
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
            let formattedLabel =
              '<span style="color:' +
              point.color +
              ';">' +
              label +
              " SAR " +
              "</span>";
            return formattedLabel;
          } else {
            label =
              point.name +
              " : " +
              this.y.toLocaleString({
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
            let formattedLabel =
              '<span style="color:' + point.color + ';">' + label + "</span>";
            return formattedLabel;
          }
        },

        // labelFormatter: function () {
        //   return '<span style="color:' + dataPoints[this.index].color + '">' + dataPoints[this.index].name + ': ' + Highcharts.numberFormat(this.y, 2) + '</span><br>';
        // },
      },
      series: [
        {
          data: dataPoints,
        },
      ],
      credits: {
        enabled: false, // Set to false to hide the credits label
      },
    };
  };

  //  function to process  data
  const processResponse4 = (res) => {
    let dt = [];
    totalVehicles = 0;
    // let colors = ["#da5e5e", "#f50057", "#7b101b", "#00c179", "#d52f2f", "#ec1c91", "#28a788", "#3f52b5e6", "#594a86", "#864a73"];
    let colors = [
      "rgb(27, 161, 234)",
      "rgb(255, 205, 25)",
      "rgb(123, 255, 109)",
      "rgb(0, 94, 32)",
      "rgb(215, 52, 250)",
      "rgb(153, 158, 255)",
      "rgb(255, 117, 153)",
      "#d52f2f",
    ];
    // let colors = ["#da5e5e", "#f50057", "#7b101b", "#00c179", "#d52f2f", "#ec1c91", "#28a788", "#3f52b5e6", "#594a86", "#864a73"];

    for (const [key, value] of Object.entries(res)) {
      let modifiedKey = key.charAt(0).toUpperCase() + key.slice(1); // Capitalize the first letter

      if (modifiedKey === "Car") {
        modifiedKey = "Sedan";
      } else if (modifiedKey === "Suv") {
        modifiedKey = "SUV";
      }

      totalVehicles = totalVehicles + value;
      dt.push({
        name: modifiedKey,
        y: value,
        value: value,
        formattedvalue: value,
      });
    }

    let makeData = [];
    dt &&
      dt.map((item, index) =>
        makeData.push({
          ...item,
          color: colors[index],
        })
      );

    const data = [{ data: makeData }];
    let someData = data;

    return {
      chart: {
        type: "pie", // Set the chart type to 'pie' for a circular chart
        height: 410,
      },
      title: {
        text: "",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "{point.percentage:.1f}%",
          },
        },
      },
      series: data,
      legend: {
        layout: "horizontal", // Display the legend horizontally
        align: "center",
        verticalAlign: "bottom", // Show legend below the chart
        itemStyle: {
          color: "gray", // Color of legend text
        },
        maxHeight: 80, // Set a fixed height
      },
      tooltip: {
        formatter: function () {
          let name = this.key;

          if (name === "Car") {
            name = "Sedan";
          } else if (name === "Suv") {
            name = "SUV";
          }

          let tooltipText =
            "<strong>" +
            props.translate(name) +
            "</strong>" +
            " <br>" +
            "<strong>" +
            Number(this.y) +
            "</strong>";

          if (name === "Others") {
            tooltipText += '<div style="max-height: 200px; overflow-y: auto;">';
            // Iterate through each key-value pair in the "Other" object
            if (typeof res.Other === "object") {
              for (const [otherName, otherValue] of Object.entries(res.Other)) {
                if (otherName !== "Total") {
                  // Display each pair on a new line
                  tooltipText +=
                    "<br><div><strong>" +
                    otherName.charAt(0).toUpperCase() +
                    otherName.slice(1) +
                    "</strong> - <strong>" +
                    Number(otherValue) +
                    "</strong></div>";
                }
              }
            }
            tooltipText += "</div>";
          }

          return tooltipText;
        },
      },

      credits: {
        enabled: false, // Set to false to hide the credits label
      },
      show: true,
    };
  };

  const processResponse10 = (res, check) => {
    // Convert the object into an array of key-value pairs
    const data = Object.entries(res);

    // Define a mapping of original keys to desired labels
    const keyLabelMapping = {
      "1_30Days": "1-30\nDays",
      "31_60Days": "31-60\nDays",
      "61_90Days": "61-90\nDays",
      "91_120Days": "91-120\nDays",
      "121_150Days": "121-150\nDays",
      "151_180Days": "151-180\nDays",
      "181_360Days": "181-360\nDays", // Line break for label
      "360_aboveDays": "360+ \nDays",
      "currentTotal ": "Current Total", // Remove the space
      currentTotal: "Current Total",
      pastDueTotal: "Past Due Total",
    };

    // Filter out "grandTotal" from the data
    const filteredData = data.filter(([key]) => key !== "grandTotal");

    const chartData = filteredData.map(([key, value]) => ({
      label: props.translate(keyLabelMapping[key]) || props.translate(key), // Use the mapped label or the original key
      name: props.translate(key), // Use the mapped label or the original key
      y: Number(value).toFixed(2), // Convert to a number, round to 2 decimal places
      formattedValue: Number(value).toLocaleString(), // Format value with commas
    }));

    // Ensure that "currentTotal" is the first column and "pastDueTotal" is the last
    chartData.sort(function (a, b) {
      if (a.label === "Current Total") return -1;
      if (b.label === "Current Total") return 1;
      if (a.label === "Past Due Total") return 1;
      if (b.label === "Past Due Total") return -1;
      return a.label.localeCompare(b.name, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });

    let colors = [
      "#ff5722",
      "#548e25",
      "#0288d1",
      "#da5e5e",
      "#f50057",
      "#7b101b",
      "#00c179",
      "#d52f2f",
    ];

    const chartOptions = {
      chart: {
        type: "column", // Set the chart type to 'column' for a vertical bar chart
        height: "400px",
      },
      title: {
        text: "",
      },
      xAxis: {
        categories: chartData.map((item) => item.label),
        title: {
          text: "",
        },
      },
      yAxis: {
        title: {
          text: "",
        },
        gridLineWidth: 0,
      },
      plotOptions: {
        column: {
          colorByPoint: true, // Use different colors for each bar
          pointPadding: 0.2, // Adjust spacing between bars
          borderWidth: 0, // Remove the border around bars
          dataLabels: {
            formatter: function () {
              // Format the label text using toLocaleString()
              return nFormatter(this.y, 2);
            },
            enabled: true,
            // format: '{point.formattedValue}', // Display the formatted value on top of the bar
          },
          point: {
            events: {
              click: function () {
                // Call your function and pass the clicked point's name as a parameter
                if (check) {
                  handleBarClick6(this.name);
                }
              },
            },
          },
        },
      },
      tooltip: {
        formatter: function () {
          const key = keyLabelMapping[this.key] || this.key;
          return (
            "<strong>" +
            props.translate(key) +
            "</strong>" +
            "<br>" +
            "<b>" +
            this.y.toLocaleString({
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) +
            " SAR " +
            "</b>"
          );
        },
      },
      // tooltip: {
      //   pointFormat: '{point.y:.2f}</b>',
      //   formatter: function () {
      //     return  "<strong>" + this.key + "</strong>" +  "<br>" +"<b>" + this.y.toLocaleString({ minimumFractionDigits: 2, maximumFractionDigits: 2, }) + " SAR " + "</b>";
      //   }
      // },
      series: [
        {
          name: "",
          showInLegend: false,
          data: chartData.map((item, index) => ({
            y: parseFloat(item.y),
            name: item.name,
            formattedValue: item.formattedValue,
            color: colors[index % colors.length], // Assign colors from the colors array
          })),
        },
      ],
      credits: {
        enabled: false,
      },
    };
    return chartOptions;
  };

  const handleBarClick6 = (pointData) => {
    let title;
    if (pointData === "1_30Days") {
      title = "1-30 Days";
    } else if (pointData === "31_60Days") {
      title = "31-60 Days";
    } else if (pointData === "61_90Days") {
      title = "61-90 Days";
    } else if (pointData === "91_120Days") {
      title = "91-120 Days";
    } else if (pointData === "121_150Days") {
      title = "121-150 Days";
    } else if (pointData === "151_180Days") {
      title = "151-180 Days";
    } else if (pointData === "181_360Days") {
      title = "181-360 Days";
    } else if (pointData === "360_aboveDays") {
      title = "360+  Days";
    } else if (pointData === "currentTotal") {
      title = "Current Total";
    } else if (pointData === "pastDueTotal") {
      title = "Past Due Total";
    }

    setShowAccountsTitle(title);

    const apiUrl = `/api/dashboards/bi/6a?value=${pointData}&contractType=1&contractType=3`;
    setShowAccountsLoader(true);
    setShowAccountsData(true);
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        // Handle the API response data as needed
        const arr = data?.data || [];
        const filteredData = arr.map((item) => {
          // Use Object.keys and Object.entries to filter out keys with 0 values
          const filteredItem = Object.fromEntries(
            Object.entries(item).filter(([key, value]) => value > 0)
          );
          return filteredItem;
        });

        setAccountsDataChart(processResponse10(filteredData[0]) || {}, false);
      })
      .catch((error) => {
        // Handle any errors that occur during the API request
        console.error("API Error:", error);
        setShowAccountsLoader(false);
      })
      .finally(() => {
        setShowAccountsLoader(false);
      });
  };

  const processResponse13 = (res, check, color) => {
    const categoryColors = {
      items: "#ff5722", // Red
      services: "#548e25", // Green
      packages: "#0288d1", // Blue
    };

    const data = Array.isArray(res) ? res : [];

    // Group the data by "yearMonth"
    const groupedData = data.reduce((grouped, item) => {
      const key = item.yearMonth;
      if (!grouped[key]) {
        grouped[key] = { yearMonth: key };
      }
      if (!grouped[key][item.categoryName]) {
        grouped[key][item.categoryName] = 0;
      }
      grouped[key][item.categoryName] += item.saleNetAmount;
      return grouped;
    }, {});

    const chartData = Object.values(groupedData);
    const categories = chartData.map((item) => item.yearMonth);

    // Determine the unique category names
    const categoryNames = Array.from(
      new Set(data.map((item) => item.categoryName))
    );

    // Rename items to parts
    categoryNames.map((categoryName) => {
      if (categoryName === "items") {
        categoryName = "parts";
      }
      return categoryName;
    });

    // Move the parts category to the beginning
    categoryNames.unshift(categoryNames.pop());

    // Move the parts category to the beginning
    // Check if there's only one unique category name
    if (categoryNames.length === 1) {
      const singleCategoryName = categoryNames[0];

      // Update the chart series and categories for a single category
      return {
        chart: {
          type: "column",
          scrollablePlotArea: {
            minWidth: 400,
            scrollPositionX: 1,
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          title: {
            text: "",
          },
          min: 0,
          max: chartData.length - 1,
          scrollbar: {
            enabled: true,
          },
          categories,
        },
        yAxis: {
          title: {
            text: props.translate("Sale Net Amount (SAR)"),
          },
          gridLineWidth: 0,
        },
        tooltip: {
          formatter: function () {
            return (
              "<strong>" +
              this.key +
              "</strong>" +
              " <br>" +
              "<strong>" +
              Number(this.y).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " SAR " +
              "</strong>"
            );
          },
        },
        plotOptions: {
          column: {
            grouping: true,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return nFormatter(this.y, 2);
              },
            },
            pointWidth: 10,
            pointPadding: 0.1,
            groupPadding: 0.1,
            events: {
              click: function (event) {
                const pointData = event.point;
                if (!check) {
                  handleBarClick(pointData);
                }
              },
            },
          },
        },
        series: [
          {
            name:
              singleCategoryName === "items"
                ? "PARTS"
                : singleCategoryName?.toUpperCase(),
            data: chartData.map((item) => item[singleCategoryName] || 0),
            color: categoryColors[singleCategoryName], // Use original category color
          },
        ],
        scrollbar: {
          enabled: true,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: data.length > 0,
        },
      };
    } else {
      // Create the chart with multiple categories
      return {
        chart: {
          type: "column",
          scrollablePlotArea: {
            minWidth: 400,
            scrollPositionX: 1,
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          title: {
            text: "",
          },
          min: 0,
          max: chartData.length - 1,
          scrollbar: {
            enabled: true,
          },
          categories,
        },
        yAxis: {
          title: {
            text: "Sale Net Amount (SAR)",
          },
          gridLineWidth: 0,
        },
        tooltip: {
          formatter: function () {
            return (
              "<strong>" +
              this.key +
              "</strong>" +
              " <br>" +
              "<strong>" +
              Number(this.y).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " SAR " +
              "</strong>"
            );
          },
        },
        plotOptions: {
          column: {
            grouping: true,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return nFormatter(this.y, 2);
              },
            },
            pointWidth: 10,
            pointPadding: 0.1,
            groupPadding: 0.1,
            events: {
              click: function (event) {
                const pointData = event.point;
                if (!check) {
                  handleBarClick(pointData);
                }
              },
            },
          },
        },
        series: categoryNames.map((categoryName, index) => ({
          name:
            categoryName === "items" ? "PARTS" : categoryName?.toUpperCase(),
          data: chartData.map((item) => item[categoryName] || 0),
          color: categoryColors[categoryName], // Use original category color
          showInLegend: chartData.some((item) => item[categoryName] > 0),
          dataLabels: {
            enabled: true, // Ensure data labels are enabled
          },
        })),
        scrollbar: {
          enabled: true,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: data.length > 0,
        },
      };
    }
  };

  const processResponse13b = (res, check, color) => {
    const categoryColors = {
      items: "#ff5722", // Red
      services: "#548e25", // Green
      packages: "#0288d1", // Blue
    };

    const data = Array.isArray(res) ? res : [];

    // Group the data by "dayOffMonth"
    const groupedData = data.reduce((grouped, item) => {
      const key = item.dayoffmonth;
      if (!grouped[key]) {
        grouped[key] = { dayoffmonth: key };
      }
      if (!grouped[key][item.categoryName]) {
        grouped[key][item.categoryName] = 0;
      }
      grouped[key][item.categoryName] += item.saleNetAmount;
      return grouped;
    }, {});

    const chartData = Object.values(groupedData);
    const categories = chartData.map((item) => item.dayoffmonth);
    // Determine the unique category names
    const categoryNames = Array.from(
      new Set(data.map((item) => item.categoryName))
    );

    // Check if there's only one unique category name
    if (categoryNames.length === 1) {
      const singleCategoryName = categoryNames[0];

      // Update the chart series and categories for a single category
      return {
        chart: {
          type: "column",
          scrollablePlotArea: {
            minWidth: 400,
            scrollPositionX: 1,
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          title: {
            text: "",
          },
          min: 0,
          max: chartData.length - 1,
          scrollbar: {
            enabled: true,
          },
          categories,
        },
        yAxis: {
          title: {
            text: "Sale Net Amount (SAR)",
          },
          gridLineWidth: 0,
        },
        tooltip: {
          formatter: function () {
            return (
              "<strong>" +
              this.key +
              "</strong>" +
              " <br>" +
              "<strong>" +
              Number(this.y).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " SAR " +
              "</strong>"
            );
          },
        },
        plotOptions: {
          column: {
            grouping: true,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return nFormatter(this.y, 2);
              },
            },
            pointWidth: 10,
            pointPadding: 0.1,
            groupPadding: 0.1,
            events: {
              click: function (event) {
                const pointData = event.point;
                if (!check) {
                  handleBarClick(pointData);
                }
              },
            },
          },
        },
        series: [
          {
            // name: singleCategoryName?.toUpperCase(),
            name:
              singleCategoryName === "items"
                ? "PARTS"
                : singleCategoryName?.toUpperCase(),

            data: chartData.map((item) => item[singleCategoryName] || 0),
            color: categoryColors[singleCategoryName], // Use original category color
          },
        ],
        scrollbar: {
          enabled: true,
        },
        credits: {
          enabled: false,
        },
      };
    } else {
      // Create the chart with multiple categories
      return {
        chart: {
          type: "column",
          scrollablePlotArea: {
            minWidth: 400,
            scrollPositionX: 1,
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          title: {
            text: "",
          },
          min: 0,
          max: chartData.length - 1,
          scrollbar: {
            enabled: true,
          },
          categories,
        },
        yAxis: {
          title: {
            text: "Sale Net Amount (SAR)",
          },
          gridLineWidth: 0,
        },
        tooltip: {
          formatter: function () {
            return (
              "<strong>" +
              this.key +
              "</strong>" +
              " <br>" +
              "<strong>" +
              Number(this.y).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) +
              " SAR " +
              "</strong>"
            );
          },
        },
        plotOptions: {
          column: {
            grouping: true,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return nFormatter(this.y, 2);
              },
            },
            pointWidth: 10,
            pointPadding: 0.1,
            groupPadding: 0.1,
            events: {
              click: function (event) {
                const pointData = event.point;
                if (!check) {
                  handleBarClick(pointData);
                }
              },
            },
          },
        },
        series: categoryNames.map((categoryName, index) => ({
          name:
            categoryName === "items" ? "PARTS" : categoryName?.toUpperCase(),
          // name: categoryName?.toUpperCase(),
          data: chartData.map((item) => item[categoryName] || 0),
          color: categoryColors[categoryName], // Use original category color
          showInLegend: chartData.some((item) => item[categoryName] > 0),
        })),
        scrollbar: {
          enabled: true,
        },
        credits: {
          enabled: false,
        },
      };
    }
  };

  const processResponse14 = (data, customColors, label) => {
    // Process the data and create the chart options
    let colors = [
      "#f2b400",
      "#0288d1",
      "#62e854",
      "#ff5722",
      "#548e25",
      "#673ab7",
      "#be1be1",
      "#005e20",
    ];

    const chartData = data?.map((item, index) => ({
      name: item.itemName,
      y: item.usedCount,
      color: colors[index % colors.length], // Use a custom color from the list
    }));

    return {
      chart: {
        type: "pie",
        height: 400, // Increase the chart's height
      },
      title: {
        text: label ? `<strong>${label}</strong>` : "",
      },
      tooltip: {
        useHTML: true, // Allow HTML content in the tooltip
        formatter: function () {
          let tooltipText =
            "<strong>" + props.translate(this.key) + "</strong>";
          tooltipText +=
            "<br><strong>" +
            Number(this.y).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) +
            "</strong>";

          if (this.key === "Other") {
            // Handle "Other" case with the list
            tooltipText +=
              '<div style="max-height: 300px; overflow-y: auto; ">'; // Add inline CSS styles
            data.forEach((item) => {
              if (item.itemCode === "Other") {
                item.list.forEach((listItem) => {
                  tooltipText += `<div><strong>${listItem.itemName
                    }</strong> (<strong>${Number(
                      listItem.usedCount
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</strong>)</div>`;
                });
              }
            });
            tooltipText += "</div>"; // Close the container div
          }

          return tooltipText;
        },
      },

      // tooltip: {
      //   formatter: function () {
      //     return (
      //       "<strong>" +
      //       this.key +
      //       "</strong>" +
      //       " <br>" +
      //       "<strong>" +
      //       Number(this.y).toLocaleString(undefined, {
      //         minimumFractionDigits: 2,
      //         maximumFractionDigits: 2,
      //       }) +
      //       "</strong>"
      //     );
      //   },
      // },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true, // Disable data labels on the chart
            format: "{point.percentage:.1f}%",
          },
          // showInLegend: true, // Show legend instead of data labels
        },
      },
      legend: {
        layout: "horizontal", // Display the legend horizontally
        align: "center",
        verticalAlign: "bottom", // Show legend below the chart
        itemStyle: {
          color: "gray", // Color of legend text
        },
        maxHeight: 80, // Set a fixed height
      },
      series: [
        {
          name: "Items",
          data: chartData,
        },
      ],
      credits: {
        enabled: false, // Set to false to hide the credits label
      },
      show: true,
    };
  };

  const handleShowAllInventoryChange = () => {
    // setSparePartsChartNew(sparePartsChart);
    if (!showAllInventory) {
      setSparePartsChartNew(processResponse14(sparePartsChart1));
    } else {
      setSparePartsChartNew(processResponse14(sparePartsChart));
    }
    setShowAllInventory(!showAllInventory);
  };

  const handleNetSalesAnalytics = () => {
    // setSparePartsChartNew(sparePartsChart);
    if (garageDataType === "station") {
      // setStationWiseChart({})
      setGarageArea("");
      setGarageDataType("area");
    } else if (garageDataType === "area") {
      // setAreaWiseChart({})
      setGarageType("");
      setGarageDataType("name");
    }
  };

  const handleShowAllServicesChange = () => {
    // setSparePartsChartNew(sparePartsChart);
    if (showAllServices) {
      setservicesPartsChartData(processResponse14(servicesPartsChart));
    } else {
      setservicesPartsChartData(processResponse14(servicesPartsChart1));
    }
    setShowAllServices(!showAllServices);
  };

  const handleShowAllVehiclesChange = () => {
    // setSparePartsChartNew(sparePartsChart);
    if (!showAllVehicles) {
      setVehiclesChart(processResponse4(ownChart1));
    } else {
      setVehiclesChart(processResponse4(ownChart));
    }
    setShowAllVehicles(!showAllVehicles);
  };

  const handleCogsChartChange = (data) => {
    // setSparePartsChartNew(sparePartsChart);
    setDataCategory(data);

    if (cogsMonthly) {
      if (data === "all") {
        setCogsChartData(processResponse13(allCogsChartData));
      } else if (data === "items") {
        setCogsChartData(processResponse13(cogsItems));
      } else if (data === "servies") {
        setCogsChartData(processResponse13(cogsServices));
      } else if (data === "packages") {
        setCogsChartData(processResponse13(cogsPackages));
      }
      // else{
      //   setCogsChartData(processResponse13(allCogsChartData))
      // }
    } else {
      if (data === "all") {
        setCogsChartData(processResponse13b(cogsChartDaily, true));
      } else if (data === "items") {
        setCogsChartData(processResponse13b(cogsSubItems, true));
      } else if (data === "servies") {
        setCogsChartData(processResponse13b(cogsSubServices, true));
      } else if (data === "packages") {
        setCogsChartData(processResponse13b(cogsSubPackages, true));
      }
      // else{
      //   setCogsChartData(processResponse13(cogsChartDaily))
      // }
    }
  };

  const handleAccountsBack = () => {
    setShowAccountsData(!showAccountsData);
  };

  const handleBarClick = (pointData) => {
    // Clicking Bar to get data of daily basis
    const { category } = pointData;
    // Split the category to separate year and month
    const [year, month] = category && category.split("-");

    const dateObj = new Date(year, month - 1); // Month is 0-based, so subtract 1

    // Format the date in the desired format
    const formattedDate = dateObj.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
    });
    setDate(formattedDate);

    const apiUrl = `/api/dashboards/bi/4b?year=${year}&month=${month}&contractType=1&contractType=3`;
    setLoader4a(true);
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        // Handle the API response data as needed
        const arr = data?.data || [];

        const itemsArray = arr?.filter((item) => item.categoryName === "items");
        const packagesArray = arr?.filter(
          (item) => item.categoryName === "packages"
        );
        const servicesArray = arr?.filter(
          (item) => item.categoryName === "services"
        );
        setCogsSubItems(itemsArray);
        setCogsSubServices(servicesArray);
        setCogsSubPackages(packagesArray);

        setCogsChartDaily(arr);
        setCogsMonthly(false);
        setDataCategory("all");
        setCogsChartData(processResponse13b(arr, true));
      })
      .catch((error) => {
        // Handle any errors that occur during the API request
        console.error("API Error:", error);
      })
      .finally(() => {
        setLoader4a(false);
      });
  };

  const handleCogsChartBack = () => {
    // setSparePartsChartNew(sparePartsChart);
    if (dataCategory === "all") {
      setCogsChartData(processResponse13(allCogsChartData));
    } else if (dataCategory === "items") {
      setCogsChartData(processResponse13(cogsItems));
    } else if (dataCategory === "servies") {
      setCogsChartData(processResponse13(cogsServices));
    } else if (dataCategory === "packages") {
      setCogsChartData(processResponse13(cogsPackages));
    }
    // else{
    //   setCogsChartData(processResponse13(allCogsChartData))
    // }
    setCogsMonthly(true);
  };

  const processResponse16 = (data, check) => {
    // Create a mapping of data keys to custom labels
    const labelMapping = {
      amountCredited: props.translate("Advance Payment"),
      totalOutstanding: props.translate("totalOutstanding"),
      totalPaid: props.translate("Total Collected"),
    };
    let customColors;
    if (check) {
      customColors = ["#548e25", "#ff5722", "#f7b400"];
    } else {
      customColors = [
        "rgb(149, 206, 255)",
        "rgb(255, 188, 117)",
        "rgb(169, 255, 150)",
        "rgb(92, 92, 97)",
        "rgb(128, 133, 233)",
        "rgb(255, 117, 153)",
      ];
    }

    // Merge totalOutstanding and totalOverDue into a single entry
    const mergedTotalOutstanding = {
      name: "Total Collected",
      y: data.totalOutstanding,
      color: customColors[1], // Use the color for Total Outstanding
    };

    const modifiedData = Object.entries(data).map(([key, value], index) => ({
      // name: props.translate(labelMapping[key]) || key, // Use custom label if available, otherwise use the key
      name: labelMapping[key] || key, // Use custom label if available, otherwise use the key
      y: value,
      color:
        key === "amountCredited"
          ? "#f7b400"
          : customColors[index % customColors.length], // Set custom colors
    }));

    // Remove the totalOverDue entry
    const filteredData = modifiedData.filter(
      (entry) => entry.name !== "totalOverDue"
    );

    // Calculate the percentage of Total Outstanding
    const totalOutstandingValue = mergedTotalOutstanding.y;
    const percentageOfTotalOutstanding =
      (totalOutstandingValue / data.totalOutstanding) * 100;

    const due = totalOutstandingValue - data.totalOverDue;

    return {
      chart: {
        type: "pie",
        height: "400px",
      },
      title: {
        text: "",
      },
      tooltip: {
        formatter: function () {
          if (this.key === "Total Outstanding") {
            return (
              "<strong>" +
              props.translate("totalOutstanding") +
              " : " +
        (totalOutstandingValue != null ? nFormatter(totalOutstandingValue, 2) : "0") +

              // Number(totalOutstandingValue).toLocaleString(undefined, {
              //   minimumFractionDigits: 2,
              //   maximumFractionDigits: 2,
              // })
               +
              " SAR</strong><br>" +
              "<strong>" +
              props.translate("totalOverdue") +
              " : " +
                      (data?.totalOverDue != null ? nFormatter(data.totalOverDue, 2) : "0") +

              // Number(data.totalOverDue).toLocaleString(undefined, {
              //   minimumFractionDigits: 2,
              //   maximumFractionDigits: 2,
              // })
               +
              " SAR</strong><br>" +
              "<strong>" +
              props.translate("totalDue") +
              " : " +
        (due != null ? nFormatter(due, 2) : "0") +

              // Number(due).toLocaleString(undefined, {
              //   minimumFractionDigits: 2,
              //   maximumFractionDigits: 2,
              // }) 
              +
              " SAR</strong>"
            );
          } else {
            return (
              "<strong>" +
              this.key +
              "</strong>" +
              " <br>" +
              "<strong>" +
        (this.y != null ? nFormatter(this.y, 2) : "0")

              // Number(this.y).toLocaleString(undefined, {
              //   minimumFractionDigits: 2,
              //   maximumFractionDigits: 2,
              // }) 
              +
              " SAR" +
              "</strong>"
            );
          }
        },
      },

      plotOptions: {
        pie: {
          innerSize: "50%", // Set the inner size to create the donut effect
          dataLabels: {
            enabled: true,
            format: "{point.name}: {point.percentage:.1f}%",
          },
        },
        series: {
          point: {
            events: {
              click: function () {
                if (!check) {
                  handleVerticalClick(this.name);
                }
              },
            },
          },
        },
      },
      series: [
        {
          name: "Yearly Data",
          data: filteredData, // Use the modified data with custom labels (totalOverDue removed)
        },
      ],
      credits: {
        enabled: false, // Set to false to hide the credits label
      },
    };
  };
  const handleUserLoginClick = (userType) => {
    setData20a((prevState) => ({
      ...prevState,
      userType,
      isVisible: true
    }))
  }
useEffect(() => {
    if (data20a?.userType && data20a?.isVisible) {
      const cachedData = saleApi20aData[data20a.userType];
      if (cachedData) {
        setData20a((prev) => ({ ...prev, data: cachedData }));
      } else {
             getEXD20a();
      }
    }
  }, [data20a?.userType, data20a?.from, data20a?.to, data20a?.isVisible, saleApi20aData]);
  const processResponse20 = (data, check) => {
    const rawData = data[0];

    const labelMapping = {
      "1": props.translate("User"),
      "2": props.translate("Admin"),
      "3": props.translate("Account Admin"),
      "4": props.translate("Service Provider"),
      "5": props.translate("Distributor"),
      "6": props.translate("Reseller"),
    };

    const customColors = check
      ? ["#548e25", "#ff5722", "#f7b400"]
      : [
        "rgb(149, 206, 255)",
        "rgb(255, 188, 117)",
        "rgb(169, 255, 150)",
        "rgb(92, 92, 97)",
        "rgb(128, 133, 233)",
        "rgb(255, 117, 153)",
      ];

    const dataPoints = Object.entries(rawData).map(([key, value], index) => ({
      name: labelMapping[key] || key,
      originalKey: key,
      y: Number(value),
      color: customColors[index % customColors.length],
    }));

    const totalUsers = dataPoints.reduce((sum, item) => sum + item.y, 0);

    return {
      chart: {
        type: "pie",
        height: 350,
      },
      title: {
        text: "",
      },
      tooltip: {
        formatter: function () {
          return `
          <strong>${this.key}</strong><br>
          <strong>${Number(this.y).toLocaleString()} Users</strong>
        `;
        },
      },
      plotOptions: {
        pie: {
          innerSize: "50%",
          dataLabels: {
            enabled: false,
            format: "{point.name[0]}: {point.percentage:.1f}%",
          },
          point: {
            events: {
              click: function () {
                if (!check) {
                  handleUserLoginClick(this.options.originalKey)
                }
              },
            },
          },
        },
      },
      series: [
        {
          name: "Users",
          data: dataPoints,
        },
      ],
      credits: {
        enabled: false,
      },
    };
  };


  const handleBarClickWrapper = (rowData, index, event) => {
    const updatedRowData = {
      ...rowData,
      category: rowData?.month || ""
    };
    handleBarClick(updatedRowData);
  };


  const handleVerticalClick = (pointData, res) => {
    // const apiUrl = `/api/dashboards/bi/14b?garageType=${pointData}`;
    // setLoader14(true);
    // fetch(apiUrl)
    //   .then((response) => response.json())
    //   .then((data) => {
    // Handle the API response data as needed
    setGarageType(pointData);

    //   setAreaWiseChart(processResponse14b(data.data));
    //   setGarageDataType("area")
    // })
    // .catch((error) => {
    //   // Handle any errors that occur during the API request
    //   console.error("API Error:", error);
    // }).finally(() => {
    //   setLoader14(false);
    // });
  };

  const handleVerticalClick2 = (pointData) => {
    setGarageArea(pointData);
  };

  const processResponse14b = (data, check) => {
    let customColors = [
      "#da5e5e",
      "#f50057",
      "#7b101b",
      "#00c179",
      "#d52f2f",
      "#ec1c91",
      "#28a788",
      "#3f52b5e6",
      "#594a86",
      "#864a73",
    ];

    const options = {
      chart: {
        type: "column",
        height: "400px",
      },
      title: {
        text: "",
      },
      tooltip: {
        formatter: function () {
          return (
            "<strong>" +
            this.key +
            "</strong>" +
            " <br>" +
            "<strong>" +
            Number(this.y).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) +
            " SAR " +
            "</strong>"
          );
        },
      },
      xAxis: {
        categories: Object.keys(data),
        title: {
          text: "",
        },
      },
      yAxis: {
        title: {
          text: "",
        },
        gridLineWidth: 0,
      },
      plotOptions: {
        column: {
          colorByPoint: true, // Use different colors for each bar
          pointPadding: 0.2, // Adjust spacing between bars
          borderWidth: 0, // Remove border around bars
          dataLabels: {
            formatter: function () {
              // Format the label text using toLocaleString()
              return nFormatter(this.y, 2);
            },
            enabled: true,
            // format: '{point.formattedValue}', // Display the formatted value on top of the bar
          },
        },
        series: {
          point: {
            events: {
              click: function () {
                if (!check) {
                  handleVerticalClick2(this.category, garageTypeC);
                }
              },
            },
          },
        },
      },

      colors: customColors, // Set the custom colors for the graph
      series: [
        {
          showInLegend: false,
          name: "Regions",
          data: Object.values(data),
        },
      ],
      credits: {
        enabled: false, // Set to false to hide the credits label
      },
    };
    return options;
  };

  const getToFrom = (value) => {
    let timezone = "";
    if (
      props.logInUser &&
      props.logInUser.attributes &&
      props.logInUser.attributes.timezone
    ) {
      timezone = props.logInUser.attributes.timezone;
    } else {
      timezone = "Asia/Riyadh";
    }

    const now = moment().tz(timezone);

    if (value === 1) {
      const startOfMonth = now.clone().startOf("month");
      const endOfMonth = now.clone().endOf("month");

      return {
        from: startOfMonth.toISOString(),
        to: endOfMonth.toISOString(),
      };
    } else if (value === 2) {
      const lastMonthStart = now.clone().subtract(1, "month").startOf("month");
      const lastMonthEnd = now.clone().subtract(1, "month").endOf("month");

      return {
        from: lastMonthStart.toISOString(),
        to: lastMonthEnd.toISOString(),
      };
    } else if (value === 3) {
      const threeMonthsAgo = now.clone().subtract(3, "months");
      const startOfThreeMonthsAgo = threeMonthsAgo.clone().startOf("month");
      const endOfLastMonth = now.clone().subtract(1, "month").endOf("month");

      return {
        from: startOfThreeMonthsAgo.toISOString(),
        to: endOfLastMonth.toISOString(),
      };
    } else if (value === 4) {
      const startOfYear = now.clone().startOf("year");

      return {
        from: startOfYear.toISOString(),
        to: now.toISOString(),
      };
    } else if (value === 6) {
      return {
        from: false,
        to: false,
      };
    } else {
      const lastYearStart = now.clone().subtract(1, "year").startOf("year");
      const lastYearEnd = now.clone().subtract(1, "year").endOf("year");

      return {
        from: lastYearStart.toISOString(),
        to: lastYearEnd.toISOString(),
      };
    }
  };

  return (
    <div >
      {/* NEW DASHBOARD  */}
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          lg={3}
        >
          <Box
            sx={{
              backgroundColor: "white",
              p: { xs: 1, md: 0.5 },
              borderRadius: "8px",
              border: "1px solid #e0e0e0",
              boxShadow: 0.5,
              height: "100%",
            }}
          >
            {(loader1 || loader2 || loader10) ? (
              Array.from({ length: 4 }).map((_, index) => (
                <Grid item xs={12} key={index}>
                  <MaintenanceItemEmpty />
                </Grid>
              ))
            ) :
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="h6">Sales</Typography>
                </Grid>
                <Grid item xs={12}>
                  <SalesCard
                    title="MTD Sales"
                    saleAmount={allSaleData?.monthlySale || 0}
                    targetAmount={allSaleData?.monthlyTarget || 0}
                    tooltipTitle={"Current Month Valid DNs w/o Vat Amount"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SalesCard
                    title="CYTD Sales"
                    isAnnualSale
                    saleAmount={allSaleData?.yearlySale || 0}
                    targetAmount={allSaleData?.yearlyTarget || 0}
                    tooltipTitle={"Current Year till Last Month Invoices (w/o VAT) + Current Month Valid DNs w/o Vat Amount"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SalesTrendCard
                    currentYearSale={currentYearSale?.currentYearSale || 0}
                    lastYearSale={currentYearSale?.lastYearSale || 0}
                    tooltipTitle={"Current Year-to-Date vs Prior Year-to-Date Invoice Amount + Current Month Valid DNs (w/o Vat)"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SalesTrendCard
                    title="Average Ticket Price Trend"
                    borderBottom={false}
                    currentYearSale={avgTicketPrice?.ytdAverageTicket || 0}
                    lastYearSale={avgTicketPrice?.lyAverageTicket || 0}
                    tooltipTitle={"Current YTD average ticket price vs prior YTD Total DNs Amount Divided By Total DNs Count(w/o Vat)"}
                  />
                </Grid>
              </Grid>
            }

          </Box>
        </Grid>

        {/* Predictive Services & Fleet Service */}
        <Grid item container xs={12} sm={6} md={3} lg={3}>
          <Grid container spacing={1}>

            <Grid item xs={12} sm={6}>
              <PredictiveCard
                amount={businessPotential?.totalBusinessPotentialCount || 0}
                amountColor="black"
                title="Predictive Services"
                isLoading={loader15}
                tooltipTitle={"Past 10 days to future 20 days Total Predicted Services"}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <PredictiveCard
                title="Business Potential"
                amount={businessPotential?.totalBusinessPotential || 0}
                amountColor="green"
                isShowCurrency
                isLoading={loader15}
                tooltipTitle={"Past 10 days to future 20 days Total Predicted Services Amount"}
              />
            </Grid>
          </Grid>


          <Grid item xs={12} mt={1}>
            <AccountsCard data={accountsData || {}} isLoading={loader5} tooltipTitle={"Total Accounts, Past 30 days Newly Created Account"}/>
          </Grid>
          <Grid item xs={12} mt={1}>
            <Card sx={{ borderRadius: 2, height: "100%" }}>
              <CardContent sx={{
                p: { xs: 1, md: 1 }, py: { xs: 1, md: 0.8 }, borderBottom: "0.5px solid lightGray",
                "&:last-child": { pb: 1 },
                paddingBottom: "28px !important",
                position: "relative",
                height: "100%"
              }} >
                {loader8 && loader8 ? (
                  <MaintenanceItemEmpty />
                ) : (
                  <>
                    <div
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography
                        variant="h6"
                        style={{ fontSize: "15px", fontWeight: 700 }}
                      >
                        {props.translate("Fleet Service Throughput")}
                      </Typography>
                      <div style={{ width: "110px", maxWidth: "120px" }}>
                        <Select
                          options={FiltersOption}
                          value={tab1}
                          onChange={(e) => handleChange("tab1", e)}
                        />
                      </div>
                    </div>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ height: { xs: 250, md: 200 }, mt: 1 }}
                    >
                      <SemiDonutChart data={fleetCountChart2} fleetCount={fleetCount} />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="subtitle2" color="text.secondary">
                          Total Invoices
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" color="#82d056" title={fleetCount?.totalDeliveryNotesCount?.toLocaleString() || 0}>
                          {nFormatter(fleetCount?.totalDeliveryNotesCount || 0, 2)}
                        </Typography>
                      </Box>
                      <Box textAlign="start">
                        <Typography variant="subtitle2" color="text.secondary">
                          Total Units Served
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" color="#ff8542" title={fleetCount?.totalServedVehicles?.toLocaleString() || 0}>
                          {nFormatter(fleetCount?.totalServedVehicles || 0, 2)}
                        </Typography>
                      </Box>
                    </Box>
                    <DashboardCardInfo title={"Total DNs Count, Total Unique Vehicles Visits"}/>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Net Sales Analytics */}
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Card sx={{ borderRadius: 0.9, height: "100%" }}>

            <CardContent sx={{
              position: "relative",
              paddingBottom: "58px !important",
            }}>

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "start",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                {
                  !loader14 &&
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        gap: 0.5,
                        minWidth: 150,
                        flexGrow: 1,
                        flexShrink: 1,
                        maxWidth: { xs: "100%", sm: "50%" },
                      }}
                    >
                      <Typography
                        variant="h6"
                        noWrap
                        sx={{ fontWeight: 700, fontSize: { xs: 14, sm: 16 } }}
                        title={translate("Net Sales Analytics") + " " + translate("SAR")}
                      >
                        {translate("Net Sales Analytics")}
                      </Typography>
                      <Typography
                        variant="h6"
                        noWrap
                        sx={{ fontWeight: 500, fontSize: { xs: 10, sm: 12 } }}
                        title={
                          garageDataType === "name"
                            ? translate("Vertical Wise")
                            : garageDataType === "area"
                              ? translate("Area Wise")
                              : garageDataType === "station"
                                ? translate("Station Wise")
                                : ""
                        }
                      >
                        {garageDataType === "name"
                          ? translate("Vertical Wise")
                          : garageDataType === "area"
                            ? translate("Area Wise")
                            : garageDataType === "station"
                              ? translate("Station Wise")
                              : ""}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        flexGrow: 1,
                        flexShrink: 1,
                        justifyContent: "flex-end",
                        minWidth: 120,
                        maxWidth: { xs: "100%", sm: "auto" },
                      }}
                    >

                      {garageDataType === "name" && (
                        <Box sx={{ width: { xs: "100%", sm: 120 }, minWidth: 80 }}>
                          <Select
                            options={FiltersOption}
                            value={tab5 ?? "All"}
                            onChange={(e) => handleChange("tab5", e)}
                            styles={{
                              container: (base) => ({ ...base, width: "100%" }),
                            }}
                          />
                        </Box>
                      )}
                      {(garageDataType === "area" || garageDataType === "station") && (
                        <Button onClick={handleNetSalesAnalytics} size="small">
                          {translate("Back")}
                        </Button>
                      )}
                    </Box>
                  </>

                }

              </Box>

              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height: { xs: 300, md: 440 } }}
              >
                {loader14 ? <MaintenanceItemEmpty /> :
                  <>

                    {garageDataType === "name" ? (
                      <DonatChart
                        data={verticalWiseChart?.series?.[0]?.data ?? []}
                        verticalWiseChart={verticalWiseChart}
                        title=""
                        subtitle=""
                        centerLabel=""
                        onSliceClick={(point) => {
                          if (point) {
                            handleVerticalClick(point.name);
                          }
                        }}
                      />
                    ) : garageDataType === "area" ? (
                      <PieChartComponent
                        data={areaWiseChart?.series?.[0]?.data ?? []}
                        allTitles={areaWiseChart?.xAxis?.categories || []}
                        onSliceClick={(point) => {
                          if (point) {
                            handleVerticalClick2(point.name, garageTypeC);
                          }
                        }}
                      />
                    ) : garageDataType === "station" ? (
                      Object.keys(areaWiseData).length === 0 ? (
                        <Typography
                          variant="h6"
                          gutterBottom
                          sx={{
                            fontSize: "16px",
                            fontWeight: 700,
                            color: "red",
                          }}
                        >
                          {translate("No Data")}
                        </Typography>
                      ) : (
                        <BarChart chartData={stationWiseChart} height={400} />
                      )
                    ) : null}
                    <DashboardCardInfo title={garageDataType==="area"?"Area Wise Sale Weightage":"Vertical Wise Sale Weightage"}/>
                  </>
                }
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Collection & Outstanding */}
        <SalePerformanceTrackerWidgets translate={props.translate}/>
        {/* <Grid item xs={12} sm={6} md={3} lg={3}> */}
          {/* <Card sx={{ borderRadius: 2 }}>
            <CardContent>
              {
                !loader6b &&
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "bold", fontSize: { xs: 16, md: 20 } }}
                  gutterBottom
                >
                  Collection & Outstanding
                </Typography>
              }
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height: { xs: 300, md: 472 } }}
              >
                {
                  loader6b ? <MaintenanceItemEmpty /> :
                    <VariablePieChart
                      newdata={collectionsAndOutStanding?.series?.[0]?.data ?? []}
                    />
                }
              </Box>
            </CardContent>


          </Card> */}
        {/* </Grid> */}
      </Grid>

      <Grid container spacing={2} mt={2}>
        <Grid item md={9} xs={12}>
          <Paper elevation={3} sx={{ p: 2, borderRadius: 2, position: "relative" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              {
                (!loader4 && !loader4a) &&
                <>
                  <Typography variant="h6" fontWeight={700}>
                    Sales Chart
                  </Typography>
                  {cogsMonthly && (
                    <div style={{ width: "120px" }}>
                      <Select
                        options={FiltersOption}
                        value={tab2 ? tab2 : "Last Year"} // Set the selected value to tab1
                        onChange={(e) => handleChange("tab2", e)}
                      />
                    </div>
                  )}
                  {!cogsMonthly && (
                    <Button
                      style={{ marginLeft: "10px" }}
                      onClick={handleCogsChartBack}
                    >
                      {props.translate("back")}
                    </Button>
                  )}
                </>
              }
            </Box>
            {loader4 || loader4a ? (
              <Grid container spacing={1} justifyContent="center">
                {Array.from({ length: 2 }).map((_, index) => (
                  <Grid item xs={12} key={index}>
                    <MaintenanceItemEmpty />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <>
                <SalesChart
                  chartData={cogsChartData}
                  handleBarClickWrapper={handleBarClickWrapper}
                  selectedMonth={date}
                />
                <DashboardCardInfo title="Monthly Sales With Respect To Services Packages And Items (w/o Vat)"/>
              </>
            )}
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={3}>
          <Paper elevation={2} sx={{ p: 2, borderRadius: 2, height: "100%", position: "relative" }}>
            {loader20 || data20a?.isLoading ? (
              <MaintenanceItemEmpty />
            ) : (
              <>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6" fontSize={16} fontWeight={700}>
                    {props.translate("User Login Stats")}
                  </Typography>
                  {
                    !data20a?.isVisible &&
                    <Box width={120}>
                      <Select
                        options={FiltersOption}
                        value={tab10 || "All"}
                        onChange={(e) => handleChange("tab10", e)}
                      />
                    </Box>
                  }
                  {
                    data20a?.isVisible &&
                    <Box width={120}>
                      <Button
                        style={{ marginLeft: "10px" }}
                        onClick={() => {
                          setData20a((prevState) => ({
                            ...prevState,
                            isVisible: false,
                            isLoading: false,
                            data: []
                          }))
                        }}
                      >
                        {props.translate("back")}
                      </Button>
                    </Box>
                  }

                </Box>
                {
                  data20a?.isVisible ?
                    <Box>

                      <Scrollbar
                        disableTracksWidthCompensation
                        style={{ height: "400px" }}
                        scrollerProps={{
                          renderer: ({ elementRef, ...rest }) => (
                            <div {...rest} ref={elementRef} id="scrollableDiv" />
                          ),
                        }}
                      >
                        {renderDataList(data20a?.data)}
                      </Scrollbar>
                    </Box> :
                    <Box mt={4}>
                      <HighchartsReact highcharts={Highcharts} options={userLogsGraphData} />
                    </Box>
                }
                <DashboardCardInfo title="User Level Wise Logins"/>
              </>
            )}
          </Paper>
        </Grid>
      </Grid>

      <WidgetsNew translate={props.translate} 
      collectionsAndOutStandingData={collectionsAndOutStanding?.series?.[0]?.data ?? []}
      collectsLoading={loader6b}
       />

    </div>
  );
};
const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
});
const renderDataList = (data, colorClass = "light-yellow") => {
  const maxCount = Math.max(...data.map(item => item.count));
  return (

    <ul className="md-bar-graphlist" style={{ margin: 0, padding: 0 }}>
      {data?.map((item, idx) => (
        <li key={idx}>
          <Box display="flex" justifyContent="space-between" className="row-label">
            <em>
              {item?.userName || item?.name || ""} - {item?.lastLogin ? moment(item.lastLogin).format('MMM D, YYYY, h:mm A') : ""}
            </em>
            <strong>{item?.count?.toLocaleString() || ""}</strong>
          </Box>
          <LinearProgress
            style={{ height: 15 }}
            className={colorClass}
            variant="determinate"
            value={(item.count / maxCount) * 100}
          />
        </li>
      ))}
    </ul>
  )

}
// loader6b
// collectionsAndOutStanding?.series?.[0]?.data ?? []

export const CollectionOutstandingCard = ({ loader, data }) => {
  return (
    <Grid item xs={12} sm={6} md={3} lg={3}>
      <Card sx={{ borderRadius: 2,boxShadow:"rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px" }}>
        <CardContent sx={{ position: "relative" }}>
          {!loader && (
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", fontSize: { xs: 16, md: 20 } }}
              gutterBottom
            >
              Collection & Outstanding
            </Typography>
          )}

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            // sx={{ height: { xs: 300, md: 472 } }}
          >
            {loader ? (
              <MaintenanceItemEmpty />
            ) : (
              <VariablePieChart newdata={data ?? []} />
            )}
          </Box>
          <DashboardCardInfo title="Total Collected Amount VS Total Outstanding VS Total Advance Amount"/>
        </CardContent>
      </Card>
    </Grid>
  );
};
export default connect(mapStateToProps)(SaleDashboard);






